import { Loader2, Save } from "lucide-react";
import { Button } from "../ui/button";

export const EditButtons = ({ loading, handleCancel, isSubmitting }) => {
  return (
    <div className="flex items-center justify-end space-x-4 pt-6 border-t border-gray-200">
              <Button
                type="button"
                variant="outline"
                onClick={handleCancel}
                disabled={isSubmitting}
              >
                Cancel
              </Button>
              <Button 
                type="submit" 
                disabled={isSubmitting} 
                className="gap-2 bg-igbanwo-mint hover:bg-igbanwo-mint/90"
              >
                {isSubmitting ? (
                  <>
                    <Loader2 className="h-4 w-4 animate-spin" />
                    Updating...
                  </>
                ) : (
                  <>
                    <Save className="h-4 w-4" />
                    Update Listing
                  </>
                )}
              </Button>
            </div>
  );
};
